<template>
  <div class="page">
    <Header title="我的积分" :leftHandler="onClickLeft"/>
    <!-- 积分 -->
    <div class="select-tab green-shadow" v-if="userRole !== '03'">
      <div @click="changePointType(2)" :class="{ 'select-tab-active': params.pointType === 2 }">
        <p>POS</p>
        <p class="color-333">剩余积分：<span>{{ posPoint }}分</span></p>
      </div>
      <div @click="changePointType(1)" :class="{ 'select-tab-active': params.pointType === 1 }">
        <p>EXTRA</p>
        <p class="color-333">剩余积分：<span>{{ extraPoint }}分</span></p>
      </div>
    </div>
    <div class="select-tab green-shadow" v-if="userRole === '03'">
      <div @click="changePointType(1)" >
        <p>EXTRA</p>
        <p class="color-333">总计获得积分：<span>{{ extraPoint }}分</span></p>
      </div>
    </div>
    <section>
      <!-- 筛选 -->
      <div class="integration-detail ">
        <div class="integration-detail-title ">
          <div>明细详情</div>
          <van-button round size="small" color="#117281" plain class="query-button"
            :icon="$getImgUrl('/wx-app-v2/img/time-filter-icon@2x.png')" :class="{ 'active': showQuery }"
            @click="showQuery = !showQuery">筛选</van-button>
        </div>
        <div class="integration-detail-screen" v-show="showQuery">
          <div class="integration-detail-input">
            <van-field class="integration-detail-input green-shadow" v-model="params.recordTimeFrom"
              placeholder="查询起始日期" readonly @click="handleShowPicker('from')" />
            <p></p>
            <van-field class="integration-detail-input green-shadow" v-model="params.recordTimeTo" placeholder="查询终止日期"
              readonly @click="handleShowPicker('to')" />
          </div>
          <div class="search-button">
            <van-button type="primary" size="small" @click="changePointType()">查询</van-button>
          </div>
        </div>
        <!-- 时间弹出层 -->
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
            @confirm="getRecordTime()" />
        </van-popup>
      </div>
      <!-- 列表 -->
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for='(pointList, index) in pointHistoryList' :key="index">
          <div class="integration-detail-item" v-if="isShow(pointList.userName)">
            <div class="row">
              <p class="integration-detail-item-point"
                :class="{ 'green': pointList.inout === 1, 'red': pointList.inout === -1 }">
                {{ pointList.inout * pointList.pointValue }}积分</p>
              <p>{{ pointList.pointTypeName }}</p>
            </div>
            <div class="row">
              <p>变更来源:</p>
              <p>
                <span v-if="pointList.userName">{{ pointList.userName }}({{pointList.userRoleName}})</span> {{ pointList.userMobile || '博世易+系统'}}</p>
            </div>
            <div class="row">
              <p>记录时间:</p>
              <p>{{ pointList.recordTime | parseTime("{y}-{m}-{d}") }} {{ pointList.recordTime | parseTime("{h}:{i}") }}
              </p>
            </div>
            <div class="row">
              <p>积分说明:</p>
              <p>{{ pointList.remark }}</p>
            </div>
          </div>
        </div>
      </van-list>
    </section>
  </div>
</template>

<script>
import Header from '@/components/header'
import centerApi from '@/api/center'
import { commonUtils } from '@/utils/common'
import { mapState } from 'vuex'
export default {
  components: {
    Header
  },
  data () {
    return {
      posPoint: 0,
      extraPoint: 0,
      pointHistoryList: [],
      loading: false,
      finished: false,
      params: {
        page: 1,
        pageSize: 20,
        recordTimeFrom: '',
        recordTimeTo: '',
        pointType: ''
      },
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      showPicker: false,
      recordType: '',
      showQuery: false
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  watch: {
    showQuery (value) {
      if (!value) {
        this.params.recordTimeFrom = ''
        this.params.recordTimeTo = ''
        this.changePointType()
      }
    }
  },
  methods: {
    parseTime: commonUtils.parseTime,
    init () {
      this.queryPointList()
    },
    // 获取总积分
    queryPointList () {
      centerApi.queryPointList().then(res => {
        if (res.data.resultCode === '0') {
          const { pointList } = res.data.resultData
          for (let i = 0; i < pointList.length; i++) {
            if (pointList[i].pointType === '1') {
              this.extraPoint += pointList[i].pointValue
            } else if (pointList[i].pointType === '2') {
              this.posPoint += pointList[i].pointValue
            }
          }
        }
      })
    },
    // 查询
    queryPointHistoryList () {
      centerApi.queryPointHistoryList(this.params).then(res => {
        if (res.data.resultCode === '0') {
          const { pointHistoryList } = res.data.resultData
          if (pointHistoryList && pointHistoryList.length) {
            this.pointHistoryList = this.pointHistoryList.concat(pointHistoryList)
          } else {
            this.finished = true
          }
          this.loading = false
          this.params.page++
        }
      })
    },
    // 切换积分类型
    changePointType (pointType) {
      if (pointType) {
        this.params.pointType = pointType
      }
      this.params.page = 1
      this.pointHistoryList = []
      this.queryPointHistoryList()
    },
    onLoad () {
      this.queryPointHistoryList()
    },
    isCassPoint (remark) {
      if (remark.indexOf('开思') > -1) {
        return true
      } else {
        return false
      }
    },
    goCassSite () {
      this.$dialog.alert({
        title: '系统提示',
        message: '请在应用市场下载开思APP查询您的订单信息！'
      })
        .then(() => {

        })
    },
    handleShowPicker (type) {
      this.recordType = type
      this.showPicker = true
      if (type === 'from') {
        this.currentDate = new Date(this.params.recordTimeFrom)
      } else if (type === 'to') {
        this.currentDate = new Date(this.params.recordTimeTo)
      }
    },
    getRecordTime () {
      if (this.recordType === 'from') {
        this.params.recordTimeFrom = this.parseTime(this.currentDate.getTime(), '{y}-{m}-{d}')
      } else if (this.recordType === 'to') {
        this.params.recordTimeTo = this.parseTime(this.currentDate.getTime(), '{y}-{m}-{d}')
      }
      this.showPicker = false
    },
    isShow (userName) {
      return this.userRole === '03' ? this.clientInfo.clientUserDTO.userName === userName : true
    },
    onClickLeft () {
      this.$router.push({ name: 'center' })
    }
  }
}
</script>

<style lang="less" scoped>
.select-tab {
  div {
    line-height: 0.6rem !important;
  }

  .color-333 {
    color: #333;
  }
}

.integration-detail {
  padding: 0.2rem 0.4rem;

}

.integration-detail-title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 35px;
  line-height: 0.76rem;
  align-items: center;

  .query-button {
    background-color: transparent;
    border: none;
  }

  .active {
    color: #117281;
    border: 2px solid #117281
  }

  img {
    width: 18px;
    height: 18px;
  }
}

.integration-detail-screen {
  display: flex;
  align-items: center;
  margin: 0.4rem 0rem 0.2rem 0rem;
  .integration-detail-input {
    padding-right: 0.3rem;
    display: flex;
    align-items: center;
    .van-cell {
      font-size: 0.3rem;
      padding: 0.15rem 0.4rem;
      border-radius: 12px;
    }
  }

  .search-button {
    flex: 0 0 20%;

    button {
      border-radius: 10px;
      width: 100%;
    }
  }

  p {
    position: relative;

    &::before {
      content: ' ';
      position: absolute;
      top: 0px;
      height: 1px;
      left: -6px;
      width: 0.3rem;
      border-top: 1px solid #117281;
    }

    margin: 0rem 0.3rem;
  }
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 0.2rem 0rem;
  font-size: 0.35rem;
}

.integration-detail-item {
  padding: 0.2rem 0.4rem;
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  margin-bottom: 0.4rem;

  .integration-detail-item-point {
    font-size: 0.75rem;
  }

  .green {
    color: #117281;
  }

  .red {
    color: rgb(228, 22, 22);
  }
}

</style>
